import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import PartialTable from 'components/partials/PartialTable';
import UsersInCellWidget from 'components/common/users/UsersInCellWidget';
import dayjs from 'dayjs';

const ProspectCustomerTable = ({
  data,
  paging,
  total,
  nextPage,
  previousPage,
  rowClassName,
  gotoPage,
  handleClickRow,
  onPageSizeChange,
  isFromManagerPage = false
}) => {
  const columns = useMemo(() => {
    const baseCols = [
      { accessor: 'id', Header: 'ID', isVisible: false },
      { accessor: 'name', Header: 'Name' },
      {
        accessor: 'createdAt',
        Header: 'Created At',
        Cell: rowData => {
          const { createdAt } = rowData.row.original;
          return (
            <div className="flex-1">
                {createdAt && dayjs(createdAt).format('DD/MM/YYYY')}
            </div>
          );
        }
      }
    ];

    if (isFromManagerPage) {
      baseCols.push({
        accessor: 'createdBy',
        Header: 'Created By',
        Cell: rowData => {
          const { createdBy } = rowData.row.original;
          return (
            <UsersInCellWidget usersText={createdBy?.toString()} showName />
          );
        }
      });
    }

    return baseCols;
  }, [isFromManagerPage]);
  return (
    <>
      <PartialTable
        data={data}
        columns={columns}
        paging={paging}
        total={total}
        nextPage={nextPage}
        previousPage={previousPage}
        gotoPage={gotoPage}
        onPageSizeChange={onPageSizeChange}
        rowClassName={rowClassName}
        handleClickRow={handleClickRow}
        textAlign=""
      />
    </>
  );
};

ProspectCustomerTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  paging: PropTypes.object,
  total: PropTypes.number,
  nextPage: PropTypes.func,
  previousPage: PropTypes.func,
  gotoPage: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  handleClickRow: PropTypes.func,
  rowClassName: PropTypes.string,
  isFromManagerPage: PropTypes.bool
};

export default ProspectCustomerTable;
